export default {
    props: {
      switchFunction: {
        type: Function,
        required: true,
      },
      
      totalSizeOfItem: {
        type: Number,
        required: false,
      },

      sizePerPage: {
        type: Function,
        required: false,
      },

      /**
       * The object that contains the pagination data.
       */
      pagination: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        pageSizes: [],
        defaultPageSize: 25,
      }
    },
    methods: {
      handleSizeChange(val) {
        this.switchFunction(this.pagination.currentPage, val);
        if (typeof this.sizePerPage !== 'undefined') this.sizePerPage(val);
      },

      handleCurrentChange(val) {
        this.switchFunction(val, this.pagination.limit);
      },

      sortLimits(value) {
        value.sort(function(a,b){ 
          return a - b;
        });
      }
    },

    created() {

      this.pageSizes = [5,10,25,50,100,150,300];
      if (this.totalSizeOfItem) {
        this.pageSizes.push(this.totalSizeOfItem);
        this.sortLimits(this.pageSizes);
        this.defaultPageSize = this.totalSizeOfItem;
      }

    }
  }



// WEBPACK FOOTER //
// ./src/app/components/paginationNew/paginationNew.js